import { useSyncExternalStore } from 'react';

const PRINT_BODY_CLASS = 'reports-print-active';

const subscribe = (onStoreChange: () => void): (() => void) => {
  const observer = new MutationObserver(onStoreChange);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
  return () => observer.disconnect();
};

const getSnapshot = (): boolean =>
  typeof document !== 'undefined' &&
  document.body.classList.contains(PRINT_BODY_CLASS);

const getServerSnapshot = (): boolean => false;

/**
 * True on the `/print` route where motion and zoom must not affect section banners.
 * @returns Whether hosted sections should use static print layout wrappers.
 */
export const useReportsPrintStaticLayout = (): boolean => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
